import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import { ILoginProps } from '../../types/propTypes';
import { ILoginState } from '../../types/stateTypes';
import LoginService from './../../services/login/login-service';
import { IAuthResponse, ILoginFormField } from '../../models/login';
import { Common } from '../../utils/constants';
import { Formik, Field } from 'formik';
import { ReactstrapInput } from '../../components/reactstrap-formik';
import { LoginValidationSchema } from '../../validation/login/login-validation';
import images from '../../assets/images/index';
import { companyNameReplace } from '../../utils';
class LoginForm extends React.Component<ILoginProps, ILoginState> {
    private initialState: ILoginFormField = {
        Email: '',
        PassWord: '',
    };
    state: ILoginState;
    loginService: LoginService;
    constructor(props: ILoginProps) {
        super(props);
        this.state = {
            apiError: '',
        };
        this.loginService = new LoginService();
    }

    handleSubmit = (value: ILoginFormField) => {
        this.loginService
            .authUser(value)
            .then(async (res: IAuthResponse) => {
                this.setState({ apiError: '' });
                this.props.onAuthUser(res);
            })
            .catch((error) => {
                let errMsg = '';
                if (error.code === Common.Auth.NOT_AUTHORIZED_EXCEPTION) {
                    errMsg = this.props.t('login.errors.defaultPasswordExpired');
                } else {
                    errMsg = this.props.t('login.errors.incorrectCredentials');
                }
                this.setState({ apiError: errMsg });
            });
    };

    handleForgotPassword = () => {
        this.props.onChangeStage(Common.AuthStage.FORGOT_PASSWORD);
    };

    render() {
        const { t, children } = this.props;
        return (
            <>
                <div className="login-block">
                    <a className="logo" href="/" title={companyNameReplace(t('login.button.instavolt'))}>
                        <img
                            className="d-block"
                            src={images.adminLogoPNG}
                            alt={companyNameReplace(t('login.button.instavolt'))}
                        />
                    </a>
                    <h1 className="title">{companyNameReplace(t('login.loginForm.header'))}</h1>

                    {this.state.apiError.length > 0 && (
                        <Alert key="errorAlert" variant="danger">
                            {this.state.apiError}
                        </Alert>
                    )}
                    <Formik
                        initialValues={this.initialState}
                        onSubmit={this.handleSubmit}
                        validationSchema={LoginValidationSchema(t)}
                        validateOnBlur={false}
                        validateOnChange={false}
                    >
                        {(props) => {
                            const { handleSubmit } = props;
                            return (
                                <form onSubmit={handleSubmit} noValidate autoComplete="off">
                                    <Field
                                        type="text"
                                        name="Email"
                                        id="Email"
                                        maxLength={50}
                                        placeholder={t('login.label.userId')}
                                        label={t('login.label.userId')}
                                        component={ReactstrapInput}
                                    />
                                    <Field
                                        type="password"
                                        name="PassWord"
                                        id="PassWord"
                                        placeholder={t('login.label.password')}
                                        label={t('login.label.password')}
                                        autoComplete="new-password"
                                        component={ReactstrapInput}
                                    />

                                    <div className="row justify-content-between no-gutters">
                                        <div className="col-auto">
                                            <div className="custom-control custom-checkbox float-left"></div>
                                        </div>
                                        <div className="col-auto text-right">
                                            <Button
                                                type="submit"
                                                color="primary"
                                                className="btn mt-2 w-100"
                                                title={t('login.button.login')}
                                            >
                                                <span>{t('login.button.login')}</span>
                                            </Button>

                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.handleForgotPassword();
                                                }}
                                                className="forgot-password d-block"
                                                title={t('login.button.forgotPassword')}
                                            >
                                                {t('login.button.forgotPassword')}
                                            </a>
                                        </div>
                                    </div>
                                    <p className="copyright">{companyNameReplace(t('login.label.copyright'))}</p>
                                </form>
                            );
                        }}
                    </Formik>
                    <div className="form-group mb-0 clearfix"></div>
                    {children}
                </div>
            </>
        );
    }
}
export default LoginForm;
